module.exports = __webpack_public_path__ + "img/bg_function06_4_t.02b12934.svg";